import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * `wrapperFormulaNode` is an abstract class for nodes this wrap another node.
 *
 * @abstract
 * @param {abstractFormulaNode} spec.expression - Wrapped node
 */
export default class WrapperFormulaNode extends AbstractFormulaNode {
	constructor({ expression } = {}) {
		super(...arguments);
		this._expression = expression;
	}

	getExpression() {
		return this._expression;
	}

	forEach(fn) {
		super.forEach(fn);
		this._expression.forEach(fn);
	}

	validate() {
		this._expression.validate(...arguments);
	}

	accept(visitor) {
		return visitor.visitWrapperNode(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.expression = this._expression;

		return properties;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.expression &&= context.factory.materialize(
			data.expression,
			context,
		);
	}
}
